import React from 'react'
import ContentBlock from '../../common/ContentBlock'
import { styled } from 'styletron-react'
import { margin, padding } from 'lostyle'
import { media, sizes } from '../../style'
import A from '../../components/A'

export const Content = styled('div', (props) => ({
  ...padding(sizes.spacing.gutter.mobile),
  ...media('tabletLandscape', {
    width: '900px',
    ...padding({
      x: '0',
      y: sizes.spacing.xl
    }),
    ...margin({
      x: 'auto'
    }),
  })
}))
Content.displayName = 'Layout.Content'


const Bold = styled('span', {
  fontWeight: '500'
})
Bold.displayName = 'Text.Bold'

const Anchor = styled('a', {
  textDecoration: 'none',
  fontWeight: '500',
  borderBottom: '1px dashed',
  color: 'hsl(200,70%,60%)',
  ':hover': {
    color: 'hsl(200,50%,50%)',
  },
})
Anchor.displayName = 'Link.Generic'

const Emphasize = styled('span', {
  fontWeight: '500',
})
Emphasize.displayName = 'Text.Emphasize'

const Info = (props) => {
  return(
    <Content>
    <ContentBlock title="hello_">
      My name is <Bold>Erik Hellman</Bold>, I am a <Emphasize>Senior Frontend Developer</Emphasize> / <Emphasize>Frontend Architect</Emphasize>.
    </ContentBlock>
    <ContentBlock title="get in touch_">
      I am currently not open for inquiries or offers.
    </ContentBlock>
  </Content>
  )
}

export default Info



// WEBPACK FOOTER //
// ./src/pages/Info/index.js